// 后端业务错误码 -> 提示文案（繁体中文）
// code 为键，val 为提示词；{0}、{1} 为位置占位符，由 t(key, args) 填充
export default {
  error_code: {
    // 预约
    '1001001': '状态不匹配',
    '1001002': '禁止修改预约',
    '1001003': '没有找到预约信息',
    '1001004': '到诊不可用',
    '1001005': '已存在预约',
    '1001006': '号源不足',
    '1001007': '禁止预约',
    '1001008': '禁止回退',
    '1001009': '没有找到患者',
    '1001010': '接口使用方式错误',
    '1001011': '没有找到预约信息【{0}】',
    '1001012': '非当天，禁止重新配药',
    // 优惠券
    '1002001': '优惠券不支持类型：{0}',
    '1002002': '优惠券名称重复',
    '1002003': '非用户券不支持发放',
    '1002004': '不可使用',
    '1002005': '不支持类型',
    '1002006': '已过期',
    '1002007': '不可修改',
    '1002008': '不可删除',
    '1002009': '存在未使用的优惠券',
    // 药品
    '1003001': '禁止保存',
    '1003002': '重复签收药品',
    '1003003': '条码不存在',
    '1003004': '药品已过期',
    '1003005': '库存不足',
    '1003006': '药品已变更',
    '1003007': '没有数据',
    '1003008': '规格不存在',
    '1003009': '金额过大，请核实或分单',
    '1003010': '组织字典映射未就绪，等待 InitOrgDict 完成',
    '1003011': '编码重复',
    '1003012': '编码不能重复',
    '1003013': '条码已存在',
    '1003014': '二维码已存在',
    '1003015': '药品已下架',
    '1003016': '药品已过期',
    '1003017': '药品不存在或已停用',
    '1003018': '药品发生变更，请重新添加',
    // 支付
    '1004001': '支付出错',
    '1004002': '下单失败',
    '1004003': '无可用付款单',
    '1004004': '已存在退款单',
    '1004005': '退款失败',
    '1004006': '不支持退款',
    '1004007': '状态不匹配',
    '1004008': '付款金额有误',
    '1004009': '收费金额有误',
    '1004010': '支付方式不可用',
    '1004011': '余额不足',
    '1004012': '订单发生变更',
    '1004013': '存在未收费项',
    '1004014': '关联预约不存在或已失效',
    '1004015': '诊治未完成，请稍后刷新重试',
    '1004016': '找不到下单的商品信息',
    '1004017': '商品发生变更',
    '1004018': '该收费项已存在',
    '1004019': '收费项【{0}】配置有误',
    '1004020': 'SourceId不能为空',
    '1004021': '收费项【{0}】没有配置浓缩药/饮片收费规则',
    '1004022': '【{0}】单据有误',
    '1004023': '【{0}】单据有误,项目不存在',
    '1004024': '单据变更，请重新发起支付',
    '1004025': '单据变更，请核实单据状态',
    '1004026': '支付中,禁止退款',
    '1004027': '已存在退款，请稍后重试',
    '1004028': '【{0}】商品已下架',
    '1004029': '【{0}】套票不可用',
    '1004030': '项目【{0}】未收费',
    // 产品
    '1005001': '已存在条码',
    '1005002': '库存不足',
    '1005003': '未启用',
    '1005006': '系统繁忙，请稍后重试',
    '1005007': '产品已下架',
    '1005008': '商品已过期',
    // 号源
    '1006001': '没有号源',
    // 工作人员
    '1007001': '不存在该工作人员',
    '1007002': '人员已停用',
    '1007003': '人员已存在',
    // 盘点
    '1008001': '盘点单不存在',
    '1008002': '药品规格不存在：{0}',
    '1008003': '当前状态不允许删除明细',
    '1008004': '盘点明细不能为空',
    // 库存调整
    '1009001': '当前状态不允许编辑',
    '1009002': '差异不能为0',
    '1009003': '药品规格不存在',
    '1009004': '【{0}】库存不足，当前库存：{1}',
    '1009005': '禁止删除',
    '1009006': '调整明细不能为空',
    // 套票
    '1010001': '已使用禁止删除',
    '1010002': '套票项目不能为空',
    '1010003': '重复项目【{0}】',
    // 其他
    '1011001': '禁止编辑',
    '1012001': '名称重复',
    // 诊所
    '2001001': '编码已存在',
    '2001002': '编码不可用',
    '2001003': '找不到该诊所',
    '2001004': '诊所不可用',
    '2001005': '参数有误',
    '2001006': '前缀不能重复',
    '2001007': '生成天数不能小于1天',
    '2001008': '间隔时间不能小于10分钟',
    // 组织
    '2002001': '编码已存在',
    '2002002': '新建组织时管理员账号和密码不能为空',
    '2002003': '组织不存在',
    '2002004': '无操作权限',
    '2002005': '手机号为空',
    '2002006': '验证码有误',
    // 密钥
    '2003001': '密钥不可用',
    '2003002': '密钥已过期',
    // 人员
    '2004001': '人员不存在',
    '2004002': '人员不可用',
    '2004003': '人员已存在',
    '2004004': '存在数据，禁止删除',
    '2004005': '存在预约禁止删除',
    // 角色
    '2005001': '角色不存在',
    '2005006': '请联系管理员进行操作！',
    // 用户
    '2006001': '用户不存在',
    '2006002': '用户不可用',
    '2006003': '组织用户数已达上限',
    '2006004': '禁止启用员工',
    '2006007': '组织编码不能为空',
    '2006008': '账号已存在',
    // 标签
    '2007001': '标签已存在',
    // 患者
    '2008001': '账号或密码错误',
    '2008002': '密码错误',
    '2008003': '证件已存在',
    '2008004': '姓名手机已存在',
    '2008005': '账号已存在',
    '2008006': '人员已存在',
    '2008007': '未找到用户',
    '2008008': '手机号不匹配',
    '2008009': '原密码不匹配',
    // 登录
    '2009001': '余额不足',
    '2009002': '域名有误',
    '2009003': '诊所不可用',
    '2009004': '诊所不存在',
    '2009005': '组织已停用，禁止登录',
    '2009006': '用户不存在',
    '2009007': '用户不可用',
    '2009008': '禁止登录！未设置初始密码，请联系管理员',
    '2009009': '密码有误，请重新输入',
    '2009010': '不属于该诊所人员，禁止登录',
    '2009011': '禁止登录！用户尚未设置密码，请联系管理员',
    '2009012': '余额不足',
    // 医健通
    '2010001': '预约不存在',
    '2010002': '医师和患者均未设置医健通ID',
    '2010003': '医师未设置医健通ID',
    '2010004': '患者未设置医健通ID',
    '2010005': '医健通ID有误，请核实',
    // 转介码
    '2011001': '转介码已存在',
    '2011002': '转介码已被患者使用，无法删除',
    // 诊治
    '3001001': '禁止修改',
    '3001002': '药品【{0}】没有设定售价',
    '3001003': '禁止重配',
    '3001004': '状态发生变更',
    '3001005': '禁止重新配药',
    '3001006': '化验单不存在',
    '3001007': '项目名称不能为空',
    '3001008': '【{0}】项目不存在',
    '3001009': '【{0}】项目已禁用',
    '3001010': '【{0}】处方小项有误',
    '3001011': '味数不一致',
    '3001012': '超过重配时限',
    '3001013': '超过重配剂数',
    '3001014': '请核实单据是否被撤回修改',
    '3001015': '配药单已配药，请勿重复操作',
    '3001016': '配药单项不存在',
    '3001017': '配药单项已配药，请勿重复操作',
    // 药品规格
    '4001001': '存在规格，禁止删除',
    // 验证码
    '5001001': '达到最大数量',
    '5001002': '稍后重试',
    '5001003': '模板未启用',
    // 通用
    '9901001': '禁止访问',
    '9901002': '服务出错',
    '9901003': '参数有误',
    '9901004': '数据异常',
    '9901005': '数据处理中',
    '9901006': '读取配置失败',
    '9901007': '操作有误',
    '9901008': '禁止编辑',
    '9901009': '禁止删除',
    '9901010': '数据重复',
    '9901011': '状态已发生变化',
    '9901012': '没有权限查询',
    '9901013': '项目不存在',
    '9902001': '登录信息有误,请重新登录',
    '9902002': '【RedisConfig】为空',
    '9902003': '文件有误',
  },
}
